/**
 * In-place Editor events defined here.
 */
/** @hidden */
export var render = 'render';
/** @hidden */
export var update = 'update';
/** @hidden */
export var destroy = 'destroy';
/** @hidden */
export var setFocus = 'set-focus';
/** @hidden */
export var accessValue = 'access-value';
/** @hidden */
export var destroyModules = 'destroy-modules';
/** @hidden */
export var showPopup = 'show-popup';



//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/node_modules/@syncfusion/ej2-angular-pdfviewer/node_modules/@syncfusion/ej2-inplace-editor/src/inplace-editor/base/events.js
// module id = ../../../../@syncfusion/ej2-angular-pdfviewer/node_modules/@syncfusion/ej2-inplace-editor/src/inplace-editor/base/events.js
// module chunks = vendor